import axiosInstance from "../../../../../../Utils/axios";
import axios from "axios";
import { paginationQueryParams } from "../../../../../../Utils/paginationParam";
let cancelToken;

const purchaseReturnURL = `api/v1/purchase-app/purchase-order-return`;

//obtaining the paginated data
export const getPurchaseReturn = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(
    `${purchaseReturnURL}/list?party_type=supplier&${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};

//obtaining all fiscal sessions
export const getAllPurchaseReturn = () =>
  axiosInstance.get(`${purchaseReturnURL}/list?party_type=supplier&ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPagePurchaseReturn = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(
    `${purchaseReturnURL}/list?party_type=supplier&${paginationQueryParams(rowsPerPage, search, "", number)}`
  );
// get by id
export const getPurchaseReturnById = (id) => axiosInstance.get(`${purchaseReturnURL}/retrieve/${id}`);

export const getPurchaseInvoiceDetail = (id) =>
  axiosInstance.get(`api/v1/purchase-app/purchase-invoice/retrieve-for-purchase-return/${id}`);

export const getPurchaseReturnAdditionalChargeList = () =>
  axiosInstance.get(`api/v1/core-app/additional-charge/list?is_active=true`);

//creating function
export const createPurchaseReturn = (body) => axiosInstance.post(`${purchaseReturnURL}/create`, body);
//updating function
export const updatePurchaseReturn = (id, body) => axiosInstance.patch(`${purchaseReturnURL}/update/${id}`, body);

//approve function
export const approvePurchaseReturn = (id) => axiosInstance.patch(`${purchaseReturnURL}/approve/${id}`);

//cancel function
export const cancelPurchaseReturn = (id) => axiosInstance.patch(`${purchaseReturnURL}/cancel/${id}`);

//searching function
export const handleSearch = ({ rowsPerPage, search, sortOrder }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(
    `${purchaseReturnURL}/list?party_type=supplier&offset=0&limit=${rowsPerPage}&ordering=${sortOrder}&search=${search}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};
